// CTA Block
($ => {

    // CTA Block Animation
    const cta = '.wp-block-ttr-cta';
    const ctaContent = document.querySelector(`${cta}__content`);

    if (cta && ctaContent) {
        // Set initial states
        gsap.set(cta, {
            opacity: 0,
            y: 100
        });

        // Get all direct children of the content container
        const contentElements = ctaContent.children;

        gsap.set(contentElements, {
            opacity: 0,
            y: 100
        });

        // Create timeline for the animation
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: cta,
                start: "top 80%",
                toggleActions: "play none none reverse",
                // markers: true
            }
        });

        // Animate the content container first
        tl.to(cta, {
            duration: 1,
            opacity: 1,
            y: 0,
            ease: "back.out"
        })
        // Then stagger animate all children
        .to(contentElements, {
            duration: 0.5,
            opacity: 1,
            y: 0,
            stagger: 0.15,
            ease: "back.out"
        }, "-=0.8"); // Overlap with the container animation
    }
})(jQuery);
